// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"252":"aa6efac8","330":"f296dbc9","515":"d281f7a1","563":"650dc798","762":"c8841d20","954":"a12b3be8"}[chunkId] + ".js";
};